/* Bianca&Noe — passaggio della taglia fra prodotti dello stesso modello.
   Vale sia per gli swatch colore sia per le tessere tessuto: al click la
   taglia selezionata viaggia in querystring e all'arrivo viene ripristinata
   se esiste nel prodotto di destinazione. */
(function () {
  'use strict';

  var PARAM = 'size';

  /* La taglia e' l'unica opzione con piu' di un valore: le opzioni a valore
     singolo (es. Color) hanno la classe selector-wrapper--single. */
  function sizeSelect() {
    var selects = document.querySelectorAll('.single-option-selector');
    for (var i = 0; i < selects.length; i++) {
      var wrap = selects[i].closest('.selector-wrapper');
      if (wrap && !wrap.classList.contains('selector-wrapper--single')) return selects[i];
    }
    return null;
  }

  /* Uscita: aggancia la taglia corrente al link cliccato. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('[data-bn-carry-size]') : null;
    if (!link) return;
    var select = sizeSelect();
    if (!select || !select.value) return;
    var url = link.getAttribute('href').split('?')[0];
    link.setAttribute('href', url + '?' + PARAM + '=' + encodeURIComponent(select.value));
  });

  /* Arrivo: se la taglia esiste nel prodotto di destinazione la preseleziona,
     anche se esaurita. Se non esiste, lascia il default del tema. */
  function restore() {
    var wanted = new URLSearchParams(window.location.search).get(PARAM);
    if (!wanted) return;
    var select = sizeSelect();
    if (!select || select.value === wanted) return;
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value === wanted) {
        select.value = wanted;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restore);
  } else {
    restore();
  }
})();
